import React from 'react';
import './footerSection.scss';
import {NavLink} from "react-router-dom";
import {
	HeaderSocialDiscord,
	HeaderSocialTelegram,
	HeaderSocialTwitter,
	HeaderSocialYoutube
} from "../images/HeaderSocialIcons";
import {useNavigate} from "react-router";

const FooterSection = () => {
	
	const handleScrollToTop = () => {
		window.scrollTo(0, 0);
	}

	const navigate = useNavigate()
	
	return (
		<div className="footerSection">
			<div className="footerSection__line"></div>
			<div className="footerSection__content">
				<div className="footerSection__content_block company">
					<h4>Company</h4>
					<div className="footerSection__content_block_items">
						<NavLink to="/about-us" onClick={() => navigate('/about-us')}>
							<span>About Us</span>
						</NavLink>
						<NavLink to="/careers" onClick={() => navigate('/careers')}>
							<span>Careers</span>
						</NavLink>
						<NavLink to="/brand-assets" onClick={() => navigate('/brand-assets')}>
							<span>Brand Assets</span>
						</NavLink>
					</div>
				</div>
				<div className="footerSection__content_block products">
					<h4>Products</h4>
					<div className="footerSection__content_block_items">
						<NavLink to="/" onClick={() => window.open("https://something.cool", "_blank")}>
							<span>Something Cool</span>
						</NavLink>
						<NavLink to="/" onClick={() => window.open("https://cooldex.cool", "_blank")}>
							<span>CoolDEX</span>
						</NavLink>
						<NavLink to="/" onClick={() => window.open("https://combine.nfd.gg", "_blank")}>
							<span>NFD Combine</span>
						</NavLink>
						<NavLink to="/nfd-platform" onClick={() => navigate('/nfd-platform')}>
							<span>NFD Platform</span>
						</NavLink>
						<NavLink to="/" onClick={() => navigate("/nfd-trade-bots")}>
							<span>NFD Trading Bots</span>
						</NavLink>
					</div>
				</div>
				<div className="footerSection__content_block docs">
					<h4>Docs</h4>
					<div className="footerSection__content_block_items">
						<NavLink to="https://nfd-gg.gitbook.io/main/eng-nfd.gg-platform/get-started" target={"_blank"}>
							<span>GitBook</span>
						</NavLink>
					</div>
				</div>
				<div className="footerSection__content_block support">
					<h4>Support</h4>
					<div className="footerSection__content_block_items">
						<NavLink to="/">
							<span>Contacts</span>
						</NavLink>
					</div>
				</div>
				<div className="footerSection__content_block socials">
					<h4>Socials</h4>
					<div className="footerSection__content_block_items">
						<button
							onClick={() => window.open('https://x.com/NFD_gg', "_blank")}
						>
							<HeaderSocialTwitter />
							{/*<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/twitter.svg`}  alt={'Twitter'}/>*/}
							<span>Twitter</span>
						</button>
						<button
							onClick={() => window.open('https://discord.gg/hfHb3AMHRP', "_blank")}
						>
							<HeaderSocialDiscord />
							{/*<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/discord.svg`}  alt={'Discord'}/>*/}
							<span>Discord</span>
						</button>
						{/*<button*/}
						{/*	onClick={() => window.open('https://www.youtube.com/')}*/}
						{/*>*/}
						{/*	<HeaderSocialYoutube />*/}
						{/*	/!*<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/youtube.svg`}  alt={'Youtube'}/>*!/*/}
						{/*	<span>Youtube</span>*/}
						{/*</button>*/}
						<button
							onClick={() => window.open('https://t.me/NFD_Trading_Bots_Ann, "_blank"')}
						>
							<HeaderSocialTelegram />
							{/*<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/telegram.svg`}  alt={'Telegram'}/>*/}
							<span>Telegram</span>
						</button>
					</div>
				</div>
			</div>
			<div className="footerSection__bottom">
				<span>© 2025 NFD, INC. ALL RIGHTS RESERVED.</span>
				<div className="footerSection__bottom_links">
					{/* <NavLink to="/terms-and-conditions">
						<span>Terms of service</span>
					</NavLink> */}
					<a href='/docs/NFD_Terms_of_Service.pdf' target='_blank' rel='noopener noreferrer'>
						<span>Terms of service</span>
					</a>
					<NavLink to="/privacy-policy">
						<span>Privacy Policy</span>
					</NavLink>
				</div>
			</div>
		</div>
	);
};

export default FooterSection;